"use client";

import * as React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { homeCardVariants } from "../foundations/home-variants";

export interface HomeLoadingStateV2Props {
  label?: React.ReactNode;
  inline?: boolean;
  compact?: boolean;
}

export function HomeLoadingStateV2({
  label,
  inline = false,
  compact = false
}: HomeLoadingStateV2Props) {
  if (inline) {
    return (
      <span className="inline-flex items-center gap-2 text-slate-500 dark:text-zinc-400">
        <Loader2 className={cn("animate-spin", compact ? "h-4 w-4" : "h-5 w-5")} />
        {!compact && (label || "Loading...")}
      </span>
    );
  }

  return (
    <div
      className={cn(
        homeCardVariants({ variant: "loading" }),
        "flex min-h-[120px] items-center justify-center rounded-2xl p-4"
      )}
    >
      <span className="inline-flex items-center gap-2 text-sm text-slate-500 dark:text-zinc-400">
        <Loader2 className="h-5 w-5 animate-spin" />
        {label || "Loading..."}
      </span>
    </div>
  );
}
